/* ═══════════════════════════════════════════════
   ZENZOZ THEME — theme.js
═══════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─── HEADER SCROLL ─── */
  const header = document.getElementById('header');
  if (header) {
    const handleScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  /* ─── HAMBURGER / MOBILE NAV ─── */
  const hamburger = document.getElementById('hamburger');
  const mobileNav = document.getElementById('mobileNav');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      hamburger.classList.toggle('open', isOpen);
      hamburger.setAttribute('aria-expanded', isOpen);
      mobileNav.setAttribute('aria-hidden', !isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded', false);
        mobileNav.setAttribute('aria-hidden', true);
        document.body.style.overflow = '';
      });
    });
  }

  /* ─── CATALOG SLIDER DRAG SCROLL ─── */
  document.querySelectorAll('.catalog-track-wrap, .featured-track-wrap, .gallery-teaser-track-wrap, .lifestyle-track-wrap').forEach(wrap => {
    let isDown = false, startX, scrollLeft;
    wrap.addEventListener('mousedown', e => {
      isDown = true;
      wrap.classList.add('dragging');
      startX = e.pageX - wrap.offsetLeft;
      scrollLeft = wrap.scrollLeft;
    });
    wrap.addEventListener('mouseleave', () => { isDown = false; wrap.classList.remove('dragging'); });
    wrap.addEventListener('mouseup', () => { isDown = false; wrap.classList.remove('dragging'); });
    wrap.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      wrap.scrollLeft = scrollLeft - (e.pageX - wrap.offsetLeft - startX);
    });
  });

  /* ─── CATALOG SLIDER NAV ARROWS ─── */
  document.querySelectorAll('.catalog-nav-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrap = document.getElementById(btn.dataset.target);
      if (!wrap) return;
      const slide = wrap.firstElementChild?.firstElementChild;
      const step = slide ? slide.offsetWidth + 16 : wrap.offsetWidth;
      wrap.scrollBy({ left: parseInt(btn.dataset.dir) * step, behavior: 'smooth' });
    });
  });

  /* ─── COLLECTION HERO BG LOAD ─── */
  const collHeroBg = document.getElementById('collHeroBg');
  if (collHeroBg) {
    const bgImg2 = new Image();
    const bgUrl2 = collHeroBg.dataset.src || '';
    if (bgUrl2) {
      bgImg2.onload = () => collHeroBg.classList.add('loaded');
      bgImg2.src = bgUrl2;
    } else {
      collHeroBg.classList.add('loaded');
    }
  }

  /* ─── REVEAL ON SCROLL ─── */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    revealEls.forEach(el => observer.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('visible'));
  }

  /* ─── LAMELLAR DECO REVEAL ─── */
  const lamellarDecos = document.querySelectorAll('.lamellar-deco');
  if (lamellarDecos.length && 'IntersectionObserver' in window) {
    const decoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          decoObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    lamellarDecos.forEach(el => decoObserver.observe(el));
  }

  /* ─── PRODUCT GALLERY ─── */
  const galleryMain = document.querySelector('.gallery-main img');
  const galleryThumbs = document.querySelectorAll('.gallery-thumb');

  if (galleryMain && galleryThumbs.length) {
    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        galleryThumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.src;
        const alt = thumb.dataset.alt;
        if (src) {
          galleryMain.style.opacity = '0';
          setTimeout(() => {
            galleryMain.src = src;
            galleryMain.alt = alt || '';
            galleryMain.style.opacity = '1';
          }, 200);
        }
      });
    });
  }

  /* ─── STICKY BAR ─── */
  const stickyBar = document.getElementById('stickyBar');
  const configSection = document.getElementById('productConfig');

  if (stickyBar && configSection) {
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(configSection);
  }

  /* ─── ACCORDION ─── */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const body = item.querySelector('.accordion-body');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.accordion-item.open').forEach(openItem => {
        openItem.classList.remove('open');
        openItem.querySelector('.accordion-body').style.maxHeight = '0';
      });

      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ─── CAROUSEL ─── */
  const carouselTrack = document.querySelector('.carousel-track');
  const carouselDots = document.querySelectorAll('.carousel-dot');
  const prevBtn = document.querySelector('.carousel-arrow--prev');
  const nextBtn = document.querySelector('.carousel-arrow--next');

  if (carouselTrack) {
    let currentSlide = 0;

    const updateCarousel = () => {
      const slides = carouselTrack.querySelectorAll('.carousel-slide');
      if (!slides.length) return;
      const slideWidth = slides[0].offsetWidth + 3; // gap
      carouselTrack.scrollTo({ left: currentSlide * slideWidth, behavior: 'smooth' });

      carouselDots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentSlide);
      });
    };

    if (prevBtn) prevBtn.addEventListener('click', () => {
      const slides = carouselTrack.querySelectorAll('.carousel-slide');
      currentSlide = Math.max(0, currentSlide - 1);
      updateCarousel();
    });

    if (nextBtn) nextBtn.addEventListener('click', () => {
      const slides = carouselTrack.querySelectorAll('.carousel-slide');
      currentSlide = Math.min(slides.length - 1, currentSlide + 1);
      updateCarousel();
    });

    carouselDots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        currentSlide = i;
        updateCarousel();
      });
    });

    // Update dots on scroll
    carouselTrack.addEventListener('scroll', () => {
      const slides = carouselTrack.querySelectorAll('.carousel-slide');
      if (!slides.length) return;
      const slideWidth = slides[0].offsetWidth + 3;
      currentSlide = Math.round(carouselTrack.scrollLeft / slideWidth);
      carouselDots.forEach((dot, i) => dot.classList.toggle('active', i === currentSlide));
    }, { passive: true });
  }

  /* ─── VARIANT SELECTION ENGINE ─── */

  const variantSelect = document.getElementById('productVariantSelect');
  const variantData = window.__variantData || [];

  function getSelectedOptions() {
    const options = {};
    document.querySelectorAll('.variant-section').forEach(section => {
      const pos = section.dataset.optionPosition;
      const active = section.querySelector('[data-value].active, .holzart-item.active, .swatch-item.active, .montage-card.active');
      if (active && pos) options[pos] = active.dataset.value;
    });
    return options;
  }

  function findMatchingVariant(selectedOptions) {
    return variantData.find(v => {
      return Object.entries(selectedOptions).every(([pos, val]) => {
        return v['option' + pos] === val;
      });
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function updateGalleryForVariant(variant, optionValue) {
    const images = window.__productImages || [];

    // Build combined keys — try both option orderings in case Shopify order differs
    const combo1 = [variant.option1, variant.option2].filter(Boolean).join(' / ').trim();
    const combo2 = [variant.option2, variant.option1].filter(Boolean).join(' / ').trim();
    const holzartKey = (variant.option1 || optionValue || '').trim();

    // Try combo (both orderings, case-insensitive), then Holzart only
    const c1 = combo1.toLowerCase();
    const c2 = combo2.toLowerCase();
    const hk = holzartKey.toLowerCase();
    let matched = images.filter(img => img.alt && (img.alt.trim().toLowerCase() === c1 || img.alt.trim().toLowerCase() === c2));
    if (!matched.length) matched = images.filter(img => img.alt && img.alt.trim().toLowerCase() === hk);

    // Fallback: use variant featured image
    if (!matched.length && variant.featured_image) {
      matched = [{ src: variant.featured_image.src.replace(/(\.\w+)$/, '_800x800$1'), alt: holzartKey }];
    }
    if (!matched.length) return;

    const mainImg = document.getElementById('galleryMainImg');
    const thumbsContainer = document.querySelector('.gallery-thumbs');

    // Update main image
    if (mainImg) {
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = matched[0].src;
        mainImg.alt = matched[0].alt;
        mainImg.style.opacity = '1';
      }, 200);
    }

    // Rebuild thumbnails
    if (thumbsContainer) {
      thumbsContainer.innerHTML = matched.map((img, i) => `
        <div class="gallery-thumb${i === 0 ? ' active' : ''}"
          data-src="${img.src}"
          data-alt="${img.alt}"
          tabindex="0"
          role="button"
        >
          <img src="${img.src.replace('_800x', '_200x')}" alt="${img.alt}" loading="lazy">
        </div>
      `).join('');

      // Re-attach thumb click events
      thumbsContainer.querySelectorAll('.gallery-thumb').forEach(thumb => {
        thumb.addEventListener('click', () => {
          thumbsContainer.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          if (mainImg && thumb.dataset.src) {
            mainImg.style.opacity = '0';
            setTimeout(() => {
              mainImg.src = thumb.dataset.src;
              mainImg.alt = thumb.dataset.alt || '';
              mainImg.style.opacity = '1';
            }, 200);
          }
        });
      });
    }
  }

  function updateVariantUI(variant, optionValue) {
    if (!variant) return;

    // Update hidden select
    if (variantSelect) variantSelect.value = variant.id;

    // Update main price
    const priceEl = document.querySelector('.price-main');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // Update add to cart button
    const addBtn = document.getElementById('addToCartBtn');
    const hasInquiry = !!document.querySelector('.ausfuehrung-item.active[data-inquiry="true"]');
    const priceRow = document.querySelector('.config-price-row');

    if (hasInquiry) {
      if (priceRow) priceRow.style.display = 'none';
      document.querySelectorAll('.holzart-price, .holzart-tax').forEach(el => el.style.display = 'none');
      document.querySelectorAll('.config-dimensions').forEach(el => el.style.display = 'none');
      openHintPopup();
      if (addBtn) {
        addBtn.dataset.variantId = variant.id;
        addBtn.dataset.inquiryMode = 'true';
        addBtn.disabled = false;
        const span = addBtn.querySelector('span');
        if (span) span.textContent = 'Produkt anfragen';
      }
    } else {
      if (priceRow) priceRow.style.display = '';
      document.querySelectorAll('.holzart-price, .holzart-tax').forEach(el => el.style.display = '');
      document.querySelectorAll('.config-dimensions').forEach(el => el.style.display = '');
      if (addBtn) {
        addBtn.dataset.variantId = variant.id;
        addBtn.dataset.inquiryMode = 'false';
        addBtn.disabled = !variant.available;
        const span = addBtn.querySelector('span');
        if (span) span.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
    }

    // Update gallery
    updateGalleryForVariant(variant, optionValue);

    updateSummary();
  }

  function onOptionChange(el) {
    const section = el.closest('.variant-section');
    if (!section) return;

    // Deactivate siblings
    section.querySelectorAll('[data-value]').forEach(s => s.classList.remove('active'));
    el.classList.add('active');

    // Update label
    const label = section.querySelector('.variant-selected');
    if (label) label.textContent = el.dataset.value;

    // Find & apply matching variant
    const selected = getSelectedOptions();
    const match = findMatchingVariant(selected);
    if (match) updateVariantUI(match, el.dataset.value);
  }

  // Attach to all option selectors
  document.querySelectorAll('.holzart-item, .swatch-item, .montage-card, .huelsen-item, .ausfuehrung-item').forEach(el => {
    el.addEventListener('click', () => onOptionChange(el));
  });

  /* ─── VARIANT SECTIONS DATA ATTR ─── */
  document.querySelectorAll('.variant-section').forEach((section, i) => {
    section.dataset.optionPosition = i + 1;
  });

  function updateSummary() {
    const holzartEl = document.getElementById('summaryHolzart');
    const ausfuehrungEl = document.getElementById('summaryAusfuehrung');
    document.querySelectorAll('.variant-section').forEach(section => {
      const active = section.querySelector('[data-value].active');
      if (!active) return;
      const val = active.dataset.value;
      if (active.classList.contains('holzart-item') && holzartEl) holzartEl.textContent = val;
      if (active.classList.contains('ausfuehrung-item') && ausfuehrungEl) ausfuehrungEl.textContent = val;
    });
  }

  /* ─── INQUIRY FORM SUBMIT ─── */
  document.getElementById('inquiryForm')?.addEventListener('submit', async (e) => {
    e.preventDefault();

    const holzart  = document.getElementById('inquiryHolzart')?.textContent || '—';
    const firma    = document.getElementById('inquiryFirma')?.value || '';
    const vorname  = document.getElementById('inquiryVorname')?.value || '';
    const name     = document.getElementById('inquiryName')?.value || '';
    const tel      = document.getElementById('inquiryTel')?.value || '';
    const email    = document.getElementById('inquiryEmail')?.value || '';
    const newsletter = document.querySelector('#inquiryForm [name="contact[newsletter]"]')?.checked ? 'Ja' : 'Nein';
    const freitext   = document.getElementById('inquiryMessage')?.value || '';
    const productTitle = '{{ product.title }}';

    const body = [
      '--- Konfiguration ---',
      `Produkt: ${productTitle}`,
      `Holzart: ${holzart}`,
      'Ausführung: Boden/Decke verspannt',
      '',
      '--- Kontakt ---',
      firma ? `Firma: ${firma}` : null,
      `Name: ${vorname} ${name}`.trim(),
      tel   ? `Telefon: ${tel}` : null,
      `E-Mail: ${email}`,
      `Newsletter: ${newsletter}`,
      freitext ? `\n--- Nachricht ---\n${freitext}` : null,
    ].filter(Boolean).join('\n');

    const form = document.getElementById('inquiryForm');
    const formData = new FormData(form);
    formData.set('contact[body]', body);
    formData.set('contact[name]', `${vorname} ${name}`.trim());

    try {
      const res = await fetch('/contact', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new URLSearchParams(formData)
      });
      if (res.ok || res.redirected) {
        closeFormPopup();
        const successOverlay = document.getElementById('inquirySuccessOverlay');
        if (successOverlay) successOverlay.classList.add('active');
        form.reset();
      }
    } catch (err) {
      console.error('Inquiry submit error:', err);
    }
  });

  /* ─── INQUIRY POPUPS ─── */
  const inquiryHintOverlay = document.getElementById('inquiryHintOverlay');
  const inquiryFormOverlay = document.getElementById('inquiryFormOverlay');

  function openHintPopup() {
    if (inquiryHintOverlay) inquiryHintOverlay.classList.add('active');
  }

  function closeHintPopup() {
    if (inquiryHintOverlay) inquiryHintOverlay.classList.remove('active');
  }

  function openFormPopup() {
    closeHintPopup();
    const holzartActive = document.querySelector('.holzart-item.active');
    const inquiryHolzart = document.getElementById('inquiryHolzart');
    if (holzartActive && inquiryHolzart) inquiryHolzart.textContent = holzartActive.dataset.value || '—';
    if (inquiryFormOverlay) { inquiryFormOverlay.classList.add('active'); inquiryFormOverlay.scrollTop = 0; }
  }

  function closeFormPopup() {
    if (inquiryFormOverlay) inquiryFormOverlay.classList.remove('active');
  }

  // Hint popup controls
  const inquiryHintClose = document.getElementById('inquiryHintClose');
  const inquiryHintClose2 = document.getElementById('inquiryHintClose2');
  if (inquiryHintClose) inquiryHintClose.addEventListener('click', closeHintPopup);
  if (inquiryHintClose2) inquiryHintClose2.addEventListener('click', closeHintPopup);
  if (inquiryHintOverlay) inquiryHintOverlay.addEventListener('click', (e) => { if (e.target === inquiryHintOverlay) closeHintPopup(); });

  // Form popup controls
  const inquiryFormClose = document.getElementById('inquiryFormClose');
  const inquiryAdjustBtn = document.getElementById('inquiryAdjustBtn');
  if (inquiryFormClose) inquiryFormClose.addEventListener('click', closeFormPopup);
  if (inquiryAdjustBtn) inquiryAdjustBtn.addEventListener('click', closeFormPopup);
  if (inquiryFormOverlay) inquiryFormOverlay.addEventListener('click', (e) => { if (e.target === inquiryFormOverlay) closeFormPopup(); });

  // Success popup
  const inquirySuccessOverlay = document.getElementById('inquirySuccessOverlay');
  const inquirySuccessClose = document.getElementById('inquirySuccessClose');
  if (inquirySuccessClose) inquirySuccessClose.addEventListener('click', () => inquirySuccessOverlay?.classList.remove('active'));
  if (inquirySuccessOverlay) inquirySuccessOverlay.addEventListener('click', (e) => { if (e.target === inquirySuccessOverlay) inquirySuccessOverlay.classList.remove('active'); });

  /* ─── SHOPIFY AJAX CART ─── */
  async function addToCart(variantId, quantity = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      if (!res.ok) throw new Error('Cart add failed');
      const data = await res.json();
      await updateCartCount();
      return data;
    } catch (err) {
      console.error('Add to cart error:', err);
    }
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    } catch (err) {
      // silent
    }
  }

  /* ─── ADD TO CART BUTTON ─── */
  const addToCartBtn = document.getElementById('addToCartBtn');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      // Inquiry mode: open contact form popup
      if (addToCartBtn.dataset.inquiryMode === 'true') {
        openFormPopup();
        return;
      }

      const form = document.getElementById('productForm');
      const variantSelect = form?.querySelector('[name="id"]');
      const variantId = variantSelect?.value || addToCartBtn.dataset.variantId;

      if (!variantId) return;

      const originalText = addToCartBtn.querySelector('span')?.textContent;
      if (addToCartBtn.querySelector('span')) {
        addToCartBtn.querySelector('span').textContent = 'Wird hinzugefügt…';
      }
      addToCartBtn.disabled = true;

      await addToCart(variantId);

      if (addToCartBtn.querySelector('span')) {
        addToCartBtn.querySelector('span').textContent = 'Im Warenkorb ✓';
      }

      setTimeout(() => {
        if (addToCartBtn.querySelector('span')) {
          addToCartBtn.querySelector('span').textContent = originalText || 'In den Warenkorb';
        }
        addToCartBtn.disabled = false;
      }, 2000);
    });
  }

  /* ─── QUICK ADD BUTTONS ─── */
  document.querySelectorAll('.product-quick-add[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      const originalText = btn.textContent;
      btn.textContent = 'Hinzugefügt ✓';
      await addToCart(variantId);
      setTimeout(() => { btn.textContent = originalText; }, 2000);
    });
  });

  /* ─── CART AJAX HELPERS ─── */
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  async function cartChange(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  function updateCartSummary(cart) {
    document.querySelectorAll('.cart-subtotal').forEach(el => {
      el.textContent = formatMoney(cart.total_price);
    });
    document.querySelectorAll('.cart-total').forEach(el => {
      el.textContent = formatMoney(cart.total_price);
    });
    document.querySelectorAll('.cart-title').forEach(el => {
      el.textContent = `Warenkorb (${cart.item_count} Artikel)`;
    });
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    });
  }

  /* ─── CART QTY SELECT ─── */
  document.querySelectorAll('.cart-qty-select').forEach(select => {
    select.addEventListener('change', async () => {
      const key = select.dataset.key;
      const qty = parseInt(select.value, 10);
      try {
        const cart = await cartChange(key, qty);
        updateCartSummary(cart);
        const priceEl = document.querySelector(`.cart-item-price[data-key="${key}"]`);
        const item = cart.items.find(i => i.key === key);
        if (priceEl && item) priceEl.textContent = formatMoney(item.final_line_price);
      } catch (err) {
        console.error(err);
      }
    });
  });

  /* ─── CART REMOVE BUTTONS ─── */
  document.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      try {
        const cart = await cartChange(key, 0);
        const itemEl = document.querySelector(`.cart-item[data-key="${key}"]`);
        if (itemEl) {
          itemEl.style.opacity = '0';
          itemEl.style.transition = 'opacity 0.25s';
          setTimeout(() => itemEl.remove(), 260);
        }
        updateCartSummary(cart);
        if (cart.item_count === 0) window.location.reload();
      } catch (err) {
        console.error(err);
      }
    });
  });

  /* ─── CART DISCOUNT TOGGLE ─── */
  const discountToggle = document.querySelector('.cart-discount-toggle');
  if (discountToggle) {
    discountToggle.addEventListener('click', () => {
      const expanded = discountToggle.getAttribute('aria-expanded') === 'true';
      discountToggle.setAttribute('aria-expanded', String(!expanded));
      const body = discountToggle.nextElementSibling;
      if (body) body.classList.toggle('is-open', !expanded);
    });

    const applyBtn = document.querySelector('.cart-discount-apply');
    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        const code = document.querySelector('.cart-discount-input')?.value.trim();
        if (code) window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/cart`;
      });
    }
  }

  /* ─── NEWSLETTER FORM ─── */
  const newsletterForm = document.getElementById('newsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = newsletterForm.querySelector('[name="contact[email]"]')?.value;
      if (!email) return;

      const submitBtn = newsletterForm.querySelector('.nl-submit');
      const originalText = submitBtn?.textContent;
      if (submitBtn) submitBtn.textContent = 'Danke!';

      // Shopify handles newsletter subscriptions via /contact form
      // This submits normally for Shopify to process
      newsletterForm.submit();
    });
  }

  /* ─── INIT CART COUNT ─── */
  updateCartCount();

})();
